/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { PaymentCurrencies } from '@mta/vela-api-types'

/**
 * Formats a price into a string with the correct currency symbol.
 *
 * @param price - the price to format
 * @param currency - the currency to use
 * @param maximumFractionDigits - the maximum number of fraction digits to display
 * @param smallestUnit - a boolean indicating if the price is in the smallest currency unit (e.g., cents)
 */
const formatPrice = (
  price: number,
  currency: PaymentCurrencies,
  maximumFractionDigits: number = 2,
  smallestUnit: boolean = false,
): string => {
  const gb = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits,
  })

  return gb.format(smallestUnit ? price / 100 : price)
}

export { formatPrice }
